import { switchOrganisationAction } from "src/page/auth/loginSlice";
import { useAppDispatch, useAppSelector } from "src/page/store";
import { refreshSession } from "src/utils/utils";
import Button from "@mui/material/Button";
import ChangeOrgModal from "../changeOrgModal/ChangeOrgModal";
import Modalui from "../UI/modal/Modalui";
import { useState } from "react";

interface Iprops {
  orgId: string;
  cb?: () => void;
  buttonText?: string;
  buttonStyle?: React.CSSProperties;
}

function AdminSwitchOrg({ orgId, cb, buttonText = "Switch", buttonStyle }: Iprops) {
  const [openChangeOrgConfirm, setOpenChangeOrgConfirm] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const { userInfo, cognitoRefreshToken } = useAppSelector((state) => state.auth);
  const handleSwitchOrganisation = () => {
    if (!userInfo || !cognitoRefreshToken) return;
    dispatch(
      switchOrganisationAction(
        {
          organisationId: orgId,
          userId: userInfo.id
        },
        () => {
          refreshSession(cognitoRefreshToken);
          setOpenChangeOrgConfirm(false);
          if (cb) cb();
        }
      )
    );
  };

  const handleCloseConfirmationModal = () => {
    setOpenChangeOrgConfirm(false);
  };

  const defaultButtonStyle = {
    color: "#fff",
    bgcolor: "#232325",
    display: "flex",
    flexWrap: "nowrap",
    height: "35px",
    fontWeight: "600",
    padding: "5px",
    textTransform: "none"
  };

  return (
    <>
      <Modalui open={openChangeOrgConfirm} handleClose={handleCloseConfirmationModal}>
        <ChangeOrgModal handleClose={handleCloseConfirmationModal} onConfirm={handleSwitchOrganisation} />
      </Modalui>
      <Button
        variant="contained"
        sx={{ ...defaultButtonStyle, ...buttonStyle }}
        onClick={() => setOpenChangeOrgConfirm(true)}
      >
        {buttonText}
      </Button>
    </>
  );
}

export default AdminSwitchOrg;
